import React, { HTMLAttributes } from 'react'

export const MerifyMCroppedSvg = ({ className, ...props }: HTMLAttributes<HTMLOrSVGElement>) => {
	return (
		<svg
			width={164}
			height={164}
			viewBox='0 0 164 164'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`merify-m-cropped${className ? ` ${className}` : ''}`}
			{...props}
		>
			<path
				d='M164 82c0 45.285-36.704 82-81.976 82S.052 127.285.052 82s36.7-82 81.972-82C127.296 0 164 36.715 164 82z'
				fill='#110BE0'
			/>
			<path
				d='M33.425 20.991c-1.8 0-4.282.501-7.252.968 0 0 2.12-2.005 5.732-4.858 2.718-2.153 6.616-4.662 6.773-4.723 6.097-2.366 11.76-4.518 17.082-4.518 9.608 0 12.98 4.256 12.98 10.273 0 13.132-16.39 34.885-21.634 40.519 0 0 0 .514.405.514 2.748 0 39.97-42.74 49.618-47.254a11.054 11.054 0 014.765-1.207 6.717 6.717 0 015.61 2.64c4.356 5.228 7.008 10.16 7.008 14.639a11.046 11.046 0 01-1.982 6.235c-4.142 6.234-16.986 25.02-16.986 27.513 0 .109 0 .222.222.222 1.394 0 5.135-4.148 5.135-4.148.871-1.21 25.998-22.267 35.167-22.267 2.975 0 4.791 3.05 4.791 5.76a4.473 4.473 0 01-1.102 3.154c-6.638 7.89-29.265 49.232-29.265 68.637 0 4.035 3.158 9.172 8.99 9.172 5.227 0 14.334-4.479 18.372-15.628 0 0 .871-1.212 1.646-1.212 1.106 0 1.655 2.179 1.655 3.159 0 9.864-27.105 47.537-56.735 47.537-10.018 0-17.13-5.611-17.13-17.719 0-8.4 3.484-20.102 11.76-35.29 0 0 11.371-21.754 11.737-24.141 0-.514-.222-.772-.622-.772a3.85 3.85 0 00-2.178 1.103c-.588.871-19 24.359-24.94 28.755-3.737 2.753-7.004 4.034-11.734 4.034-9.865 0-25.123-3.485-25.123-8.618 0-.989.366-2.091 1.307-3.376 3.375-4.732 17.383-23.257 17.383-23.257 0-1.285-.11-2.178-.514-2.178-.218 0-.405.109-.767.479-1.507 1.503-27.213 28.646-32.017 31.369a27.854 27.854 0 01-6.904 2.728A86.83 86.83 0 01.205 88.073c-.78-8.922.928-19.527.94-19.54C19.174 52.97 36.63 32.676 36.63 23.488c-.104-1.795-1.206-2.497-3.205-2.497z'
				fill='#FF4856'
			/>
		</svg>
	)
}
